module.exports = __webpack_public_path__ + "static/media/ubelens-logo-white.f7bc8619.png";